module.exports = __webpack_public_path__ + "media/images/svg/download-c735c5ef8af4c143e7b36c5bf01ef45c.svg";